import { Theme } from '@mui/material/styles'

export default function Table(theme: Theme) {
  return {
    MuiTable: {
      styleOverrides: {
        root: {
          // Avoid borderStyle: 'hidden' — it can suppress cell borders on first paint in some browsers.
          border: 'none',
          borderWidth: 0
        }
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          overflow: 'hidden',
          borderRadius: 12,
          border: `1px solid ${theme.palette.grey[500_12]}`,
          '& .MuiTable-root': {
            borderCollapse: 'separate',
            borderSpacing: 0
          },
          '& thead tr:first-child th:first-of-type': {
            borderTopLeftRadius: 11
          },
          '& thead tr:first-child th:last-of-type': {
            borderTopRightRadius: 11
          },
          '& tbody tr:last-child td:first-of-type': {
            borderBottomLeftRadius: 11
          },
          '& tbody tr:last-child td:last-of-type': {
            borderBottomRightRadius: 11
          }
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover
            }
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          boxSizing: 'border-box'
        },
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.neutral,
          '&:first-of-type': {
            paddingLeft: theme.spacing(3)
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(3)
          }
        },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`
        },
        body: {
          '&:first-of-type': {
            paddingLeft: theme.spacing(3)
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(3)
          }
        }
      }
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: `solid 1px ${theme.palette.divider}`
        },
        toolbar: {
          height: 64
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius
          }
        },
        selectIcon: {
          width: 20,
          height: 20,
          marginTop: -4
        }
      }
    }
  }
}
